/**
 * wl-variant-rules.js — Woollooms özel varyant kuralları
 *
 * AMAÇ (2026-07-23 talebi):
 *   Seçili Shape'e (veya genel olarak önceki seçeneklere) AİT OLMAYAN ölçüler
 *   ürün sayfasında hiç görünmesin — üzeri çizili/pasif olarak da durmasın.
 *   Örn: Shape = Round/Oval seçiliyken Rectangle ölçüleri listelenmesin.
 *
 * AYRIM (önemli):
 *   - Kombinasyon YOK  (o shape+ölçü varyantı hiç yaratılmamış)  → TAMAMEN GİZLE
 *   - Kombinasyon VAR ama STOK YOK (variant.available === false) → dokunma,
 *     temanın kendi üzeri-çizili görünümü kalsın (istek: "stok bitmişse gözükmesinde sıkıntı yok").
 *
 * Temanın theme.js'ine dokunulmaz; bu dosya onun üstüne ek katman olarak çalışır.
 */
(function () {
  var HIDE_CLASS = 'wl-combo-hidden';

  function getVariants(picker) {
    if (picker.__wlVariants) return picker.__wlVariants;
    var node = picker.querySelector('[data-variants]');
    if (!node) return (picker.__wlVariants = []);
    try {
      picker.__wlVariants = JSON.parse(node.textContent) || [];
    } catch (e) {
      picker.__wlVariants = [];
    }
    return picker.__wlVariants;
  }

  function apply(picker) {
    var variants = getVariants(picker);
    if (!variants.length) return;

    var groups = Array.prototype.slice.call(picker.querySelectorAll('fieldset'));
    if (groups.length < 2) return;

    // Her seçenek grubunda o an seçili değer
    var selected = groups.map(function (g) {
      var checked = g.querySelector('input[type="radio"]:checked');
      return checked ? checked.getAttribute('value') : null;
    });

    groups.forEach(function (group, gi) {
      if (gi === 0) return; // ilk seçenek (Shape) filtrelenmez — hepsi görünür kalır

      var inputs = Array.prototype.slice.call(group.querySelectorAll('input[type="radio"]'));

      inputs.forEach(function (input) {
        var value = input.getAttribute('value');

        // Bu değerle, önceki seçeneklerin SEÇİLİ değerlerini birlikte taşıyan
        // bir varyant var mı? (stok durumuna BAKMADAN — sadece "var mı yok mu")
        var exists = variants.some(function (v) {
          for (var i = 0; i < gi; i++) {
            if (selected[i] === null) continue;
            if (v['option' + (i + 1)] !== selected[i]) return false;
          }
          return v['option' + (gi + 1)] === value;
        });

        var li = input.closest('li');
        if (li) li.classList.toggle(HIDE_CLASS, !exists);

        // Gizlenen seçenekte "üzeri çizili" durumunu bırakma (geri açılırsa temiz gelsin)
        if (!exists) input.classList.remove('disabled');
      });
    });
  }

  function applyAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll('variant-picker'), apply);
  }

  // Kullanıcı seçenek değiştirdiğinde: olay önce temanın kendi işleyicisine gider
  // (variant-picker elementi üzerinde), bize document'te ulaşır → biz en son çalışırız.
  document.addEventListener('change', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var picker = target.closest('variant-picker');
    if (picker) requestAnimationFrame(function () { apply(picker); });
  });

  // İlk yükleme
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { applyAll(); });
  } else {
    applyAll();
  }

  // Theme Editor / dinamik bölüm yüklemeleri
  document.addEventListener('shopify:section:load', function (e) { applyAll(e.target); });
})();
